// extracted by mini-css-extract-plugin
export default {"base":"Surveillance_base__f-KoF","header":"Surveillance_header__GCc0h","content":"Surveillance_content__tY6+5","body":"Surveillance_body__IgEDZ"};